import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to set document title based on current route
 * - Public pages: "GB Sylt Shop"
 * - Admin pages: "GB Sylt Shop Admin"
 * - Can be extended for page-specific titles later
 */
export const useDocumentTitle = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const isAdmin = pathname.startsWith('/admin');
    
    // Base titles
    const publicTitle = 'GB Sylt Shop';
    const adminTitle = 'GB Sylt Shop Admin';
    
    // Set title based on route
    if (isAdmin) {
      document.title = adminTitle;
    } else {
      document.title = publicTitle;
    }
  }, [pathname]);
};

/**
 * Component wrapper for the hook (for use in App.js)
 */
export const DocumentTitle = () => {
  useDocumentTitle();
  return null;
};
